import http from './api'

const route = '/avisos/'

export default {
    listarAvisos: (chaveativacao, listaVisualizados) => {
        return http.post(route + 'lista_avisos', { chaveativacao: chaveativacao, listaVisualizados: listaVisualizados })
    },
    getAviso: (id, idProdutor) => {
        return http.post(route + 'aviso', { id: id, produtorId: idProdutor })
    },
    carregaHistoricoAvisos: (chaveativacao) => {
        return http.post(route + 'historico_avisos', { chaveativacao: chaveativacao })
    },
    setVisualizado: (chaveativacao, avisoId, produtorId) => {
        return http.post(route + 'aviso_visualizado', { chaveativacao: chaveativacao, avisoId: avisoId, produtorId: produtorId })
    },
}
